
export class UserCreateModel {
  orgUnitId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  timeZoneId: string;
  culture: string;
  sendMail: boolean;
}
